module.exports = __webpack_public_path__ + "static/img/5.3f500ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/5.jpg
// module id = 1neZ
// module chunks = 15